import { useContext } from 'react';
import { DataContext, MembershipDataContext } from './DataProvider';

export const useData = () => {
    const context = useContext(DataContext) as MembershipDataContext | undefined;
    if (!context) {
        throw new Error('useData must be used within DataProvider');
    }
    return context;
};
